module.exports = __webpack_public_path__ + "static/media/insitu_con_pok.84c72ab1.png";